module.exports = __webpack_public_path__ + "img/U1F602.3a5fecf9.png";